var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"text-base no-data-position m-0"},[_c('b-col',{staticClass:"text-center"},[_c('div',{staticClass:"text-12"},[_c('span',[_vm._v("Não há dados para apresentar")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }